module.exports = __webpack_public_path__ + "9a058d18b25fa5ab697e2f7dd7eb09bc.png";